import { render, staticRenderFns } from "./UserLookup.vue?vue&type=template&id=27438fb2&"
import script from "./UserLookup.vue?vue&type=script&lang=js&"
export * from "./UserLookup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports